module.exports = __webpack_public_path__ + "static/media/gym-bg.d99f437f.png";